import { forwardRef } from 'react';
import { cn } from '../utils/cn';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, error, type = 'text', ...props }, ref) => (
    <input
      ref={ref}
      type={type}
      className={cn(
        'h-11 px-3.5 w-full',
        'bg-white border border-ink-300 rounded-md',
        'text-[14px] text-ink-900 placeholder:text-ink-400',
        'transition-[border-color,box-shadow] duration-fast ease-mela',
        'focus:outline-none focus:border-saffron-500 focus:ring-4 focus:ring-saffron-500/[0.12]',
        'disabled:bg-ink-100 disabled:cursor-not-allowed',
        error && 'border-vermilion-500 focus:border-vermilion-500 focus:ring-vermilion-500/[0.12]',
        className
      )}
      {...props}
    />
  )
);
Input.displayName = 'Input';
